import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import SPCOrderNotesState from "@tCentro/Store/Reducer/CENSPCOrderNotesState";
import { Draft } from "immer";

const initialState: SPCOrderNotesState = {
    OrderNotes: "",
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/CheckoutReview/SetOrderNotes": (
        draft: Draft<SPCOrderNotesState>,
        action: { OrderNotes: string },
    ) => {
        draft.OrderNotes = action.OrderNotes;
    },
});
